export default __webpack_public_path__ + "d58757b9219ceb13da542273879fb783.ttf";